import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import useDataSourceContext from '../../DataSource/useDataSourceContext';

const DataListSelectionCheckbox = ({ item, component: Component }) => {
  const { selection: selectionModule = {} } = useDataSourceContext();
  const { toggleItemSelection, isItemSelected } = selectionModule;

  return (
    <Component>
      <Checkbox
        edge="start"
        tabIndex={-1}
        disableRipple
        checked={isItemSelected(item.id)}
        onChange={() => toggleItemSelection(item.id)}
      />
    </Component>
  );
};

DataListSelectionCheckbox.propTypes = {
  item: PropTypes.object.isRequired,
  component: PropTypes.oneOfType([
    PropTypes.element,
    // eslint-disable-next-line react/no-typos
    PropTypes.elementType,
    PropTypes.node,
    PropTypes.string,
  ]),
};

DataListSelectionCheckbox.defaultProps = {
  component: props => <Box pl={2} pr={0} {...props} />,
};

export default DataListSelectionCheckbox;
